import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ParaSharedLayoutComponent } from './para-shared-layout.component';
import { LmsAssessmentModule } from '@para/shared/lms-assessment/lms-assessment.module';
import { ParaFooterModule } from '@para/shared/components/para-footer/para-footer.module';

/** PARA shell (`/progress`): layout + LMS slideout; use in-widget {@link ParaComponentLoaderComponent} for loading (no global HTTP strip). */
@NgModule({
	declarations: [ParaSharedLayoutComponent],
	imports: [CommonModule, RouterModule, LmsAssessmentModule, ParaFooterModule],
	exports: [ParaSharedLayoutComponent],
})
export class ParaShellModule {}

export { ParaShellModule as ParaSharedLayoutModule };
